/* ================================================== */
/* ACCESSIBILITY → Nav
/* ================================================== */

$(document).ready(function() {
	var $nav = $('.nav .menu');

	function accessibilityNav() {
		if (breakpointXs && $nav.offset().top + $nav.outerHeight() > $(window).scrollTop()) {
			$('.nav__link', $nav).attr('tabindex', '0');
		} else if (breakpointXs) {
			$('.nav__link', $nav).attr('tabindex', '-1');
		}
	}

	$(window).on('resize orientationchange', function() {
		accessibilityNav();
	});

	$(window).scroll(function() {
		accessibilityNav();
	});
});